import { APP_TYPE, AppType } from "../../app.type";
import { bulkDocsByType, getDocsByType } from "../../api.service";
import { Inject, Injectable } from "@angular/core";
import { ManufacturerResponsibleServiceType } from "./manufacturer-responsible.service.type";
import { StringUtils } from "../../../../../shared/utils/string.utils";
import {
  ManufacturerResponsible,
  ManufacturerResponsibleRow,
  ManufacturerResponsibles
} from "../../../../../shared/models/manufacturerResponsible";

/**
 * The manufacturerResponsibles document is only written here - it is read by the
 * LCM project, to set the responsible on an alert based on the manufacturer name.
 */
@Injectable()
export class ManufacturerResponsibleService
  implements ManufacturerResponsibleServiceType
{
  constructor(@Inject(APP_TYPE) private app: AppType) {}

  generateManufacturerResponsibles(rows: ManufacturerResponsibleRow[]) {
    this.app.import.docs = rows;
    rows.forEach((row) => {
      this.app.import.selected.add(row.manufacturerName);
    });

    this.app.import.stepper = "reviewList";
    this.app.import.step = "third";
    return this.app.import.docs;
  }

  groupRowsByResponsible(rows: ManufacturerResponsibleRow[]) {
    const setsByResponsible = new Map<string, ManufacturerResponsible>();

    rows.forEach((row) => {
      if (
        StringUtils.isNullOrEmpty(row.responsible) ||
        StringUtils.isNullOrEmpty(row.manufacturerName)
      ) {
        return;
      }

      let set = setsByResponsible.get(row.responsible);
      if (set == null) {
        set = new ManufacturerResponsible();
        set.responsible = row.responsible;
        setsByResponsible.set(row.responsible, set);
      }
      if (!set.names.includes(row.manufacturerName)) {
        set.names.push(row.manufacturerName);
      }
    });

    return [...setsByResponsible.values()];
  }

  async saveManufacturerResponsiblesDoc(doc: ManufacturerResponsibles) {
    const oldDocs = await getDocsByType(
      this.app.customers.expectCurrent,
      "manufacturerResponsibles"
    );

    /** only one document of this type is kept - delete the old one before saving the new */
    if (oldDocs.length > 0) {
      oldDocs[0]._deleted = true;
      await bulkDocsByType(
        this.app.customers.expectCurrent,
        "manufacturerResponsibles",
        oldDocs
      );
    }

    await bulkDocsByType(
      this.app.customers.expectCurrent,
      "manufacturerResponsibles",
      [doc]
    );
  }
}
